import { IGroupByListColumn } from "models";

type GroupedFieldsT = Map<string, IGroupByListColumn[]>;

export const fieldGroupKey = (item: IGroupByListColumn): string =>
  `${item.subgroup}${item.published === false ? "||test" : ""}`;

// A Map, not an object: callers render blocks in iteration order, which must be
// first appearance even for integer-like keys (e.g. a "6668" subgroup).
const groupFields = (items: IGroupByListColumn[]): GroupedFieldsT => {
  const result: GroupedFieldsT = new Map();

  for (const item of items ?? []) {
    const key = fieldGroupKey(item);
    const group = result.get(key);
    if (group) group.push(item);
    else result.set(key, [item]);
  }

  return result;
};

export default groupFields;
